module.exports = __webpack_public_path__ + "static/media/g4006.dba5ef8f.png";